"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelativeTimeChip = void 0;
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const Tooltip_1 = __importDefault(require("@opsbase/web-ui/Tooltip"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const react_1 = __importStar(require("react"));
function RelativeTimeChip(props) {
    var _a;
    const { time, timezone = moment_timezone_1.default.tz.guess(), format } = props;
    const localTimezone = moment_timezone_1.default.tz.guess();
    const sameTimezone = timezone === moment_timezone_1.default.tz.guess();
    const t = (0, moment_timezone_1.default)(time).tz(timezone);
    const localT = (0, moment_timezone_1.default)(time).tz(localTimezone);
    const outTime = format ? t.format(format) : t.fromNow();
    return (react_1.default.createElement(Tooltip_1.default, { tip: react_1.default.createElement(react_1.Fragment, null,
            !sameTimezone && (react_1.default.createElement(Text_1.default, null,
                localT.format('z'),
                ":\u00A0",
                localT.format('lll'))),
            react_1.default.createElement(Text_1.default, null,
                t.format('z'),
                ":\u00A0",
                t.format('lll'))) },
        react_1.default.createElement(Text_1.default, { style: (_a = props.textStyle) !== null && _a !== void 0 ? _a : { textAlign: props.textAlign, color: props.color } }, outTime)));
}
exports.RelativeTimeChip = RelativeTimeChip;
exports.default = RelativeTimeChip;
